export default __webpack_public_path__ + "static/media/article2.c5662d09.jpg";